import React, { useState } from 'react';
import { ShopOutlined } from '@ant-design/icons';

export function getMerchantInitials(name: string | undefined | null): string {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }
  return name.trim().slice(0, 2).toUpperCase();
}

export function merchantAvatarColor(name: string | undefined | null): string {
  const seed = name?.trim() ?? '';
  if (!seed) return '#ffedd5';
  const colors = [
    '#fce7f3',
    '#dbeafe',
    '#dcfce7',
    '#ffedd5',
    '#ede9fe',
    '#ccfbf1',
    '#fee2e2',
    '#e2e8f0',
  ];
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash + seed.charCodeAt(i)) % colors.length;
  }
  return colors[hash];
}

export interface MerchantAvatarProps {
  name?: string | null;
  imageUrl?: string | null;
  size?: number;
  borderRadius?: number | string;
  className?: string;
}

export const MerchantAvatar: React.FC<MerchantAvatarProps> = ({
  name,
  imageUrl,
  size = 32,
  borderRadius = 8,
  className,
}) => {
  const [imgFailed, setImgFailed] = useState(false);
  const label = name?.trim() || '?';
  const url = imageUrl?.trim();

  const boxStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius,
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: merchantAvatarColor(label),
    color: '#374151',
    fontWeight: 700,
    fontSize: Math.max(10, size * 0.34),
  };

  if (url && !imgFailed) {
    return (
      <img
        src={url}
        alt={label}
        className={className}
        style={{ ...boxStyle, objectFit: 'cover' }}
        onError={() => setImgFailed(true)}
      />
    );
  }

  const initials = getMerchantInitials(label);
  if (initials !== '?') {
    return (
      <div className={className} style={boxStyle} aria-label={label}>
        {initials}
      </div>
    );
  }

  return (
    <div className={className} style={boxStyle} aria-label={label}>
      <ShopOutlined style={{ fontSize: size * 0.45, color: '#ea580c' }} />
    </div>
  );
};
